module.exports = __webpack_public_path__ + "static/media/warningValid.4de164c5.svg";